<script setup lang="ts">
import { computed } from 'vue';
import { Pie } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, type ChartData, type ChartOptions } from 'chart.js';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

// Define your DataItem interface (matches your backend)
interface DataItem {
  name: string;
  total: number;
}

// Props definition
const props = defineProps({
	size: {
		type: String as () => 'small' | 'medium' | 'large',
		default: 'large',
	},
	height: {
		type: String,
		required:false,
		default:"400px"
	},
	data: {
		type: Array as () => DataItem[],
		required: true,
	},
	colors: {
		type: Array as () => string[],
		default: () => ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
	},
});

// Transform DataItem[] to Chart.js format
const chartData = computed<ChartData<'pie'>>(() => ({
  labels: props.data.map(item => item.name),
  datasets: [{
    data: props.data.map(item => item.total),
    backgroundColor: props.colors,
    borderColor: '#ffffff',
    borderWidth: 1,
  }],
}));

// Strictly typed Chart.js options
const options = computed<ChartOptions<'pie'>>(() => ({
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
	    display:false
    },
  },
}));
</script>

<template>
  <div class="bg-white rounded-lg p-4 shadow" :class="{ 'w-full ': size === 'large', 'w-full h-[300px]': size === 'medium', 'w-full h-[200px]': size === 'small', }" :style="'height:'+props.height">
    <Pie :data="chartData" :options="options" />
  </div>
</template>
